import { render, staticRenderFns } from "./saleTrend.vue?vue&type=template&id=60b05900&scoped=true&"
import script from "./saleTrend.vue?vue&type=script&lang=js&"
export * from "./saleTrend.vue?vue&type=script&lang=js&"
import style0 from "./saleTrend.vue?vue&type=style&index=0&id=60b05900&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b05900",
  null
  
)

export default component.exports